export const IMAGE_URLS = {
  logo: 'https://user-images.githubusercontent.com/81489300/174609837-86af1ad0-8b87-4e6f-bc05-88b38b7a6d91.png',
  smallLogo:
    'https://user-images.githubusercontent.com/79133602/173178383-98e2df29-83b8-4a6e-8e81-4ead530fd97a.png',
  PROFILE_IMG:
    'https://user-images.githubusercontent.com/81489300/173558585-118a6c7e-57af-4058-aba9-a404c08881bf.png',
  POST_DEFAULT_IMG:
    'https://user-images.githubusercontent.com/81489300/174609870-0d1ef181-46b0-4150-abdb-397d49193f1d.jpg',
  POST_ADD_IMG:
    'https://user-images.githubusercontent.com/81489300/173825583-b9b565f0-487c-4d35-ae17-51bd9d429198.png',
  FLOWERPOT:
    'https://user-images.githubusercontent.com/81489300/174393084-1cb47850-52b9-489f-b533-a8cbeddf19ea.png',
  POST_DEFAULT_GRID_IMG:
    'https://user-images.githubusercontent.com/79133602/173282447-b5cdf98e-4372-4284-9795-b824acf2283d.png',
  POST_PLACEHOLDER: 'https://via.placeholder.com/200',
};

export const IMAGE_NAMES = {
  LOGO_IMAGE: 'logo',
  SMALL_LOGO_IMAGE: 'smallLogo',
  POST_DEFAULT_GRID_IMG: 'POST_DEFAULT_GRID_IMG',
};
